import React, { ReactComponentElement } from 'react';
import { Grid } from '@material-ui/core';

type Item = ReactComponentElement<any> | HTMLElement;

type Column = Item[];

type Props = {
  columns: Column[];
};

const EqualColumns: React.FC<Props> = ({ columns }) => {
  const map = new Map<number, 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12>([
    [1, 12],
    [2, 6],
    [3, 4],
    [4, 3],
    [6, 2],
    [12, 1],
  ]);
  const colWidth = map.get(columns.length) || 'auto';

  return (
    <Grid container spacing={1}>
      {columns.map((column, columnIndex) => (
        <Grid container item lg={colWidth} xs={12} spacing={1} key={`column-${columnIndex}`}>
          {column.map((item, itemIndex) => (
            <Grid item xs={12} key={`column-${columnIndex}-item-${itemIndex}`}>
              {item}
            </Grid>
          ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default EqualColumns;
